import React, { Component } from "react";
import { Field } from "formik";
import { connect } from "react-redux";
import style from "./ExternalPractitionerInfo.module.css";
import { fetchDropdownList, fetchDisciplineList } from "../../../redux";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { Select } from "antd";
const { Option } = Select;

export class ExternalPractitionerInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScreenLoaded: false,
    };
  }
  componentDidMount = () => {
    this.props.fetchDisciplineList();
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 500);
  };

  goBack = () => {
    this.props.navigateBack();
  };

  goNext = () => {
    this.props.navigateNext();
  };
  goNextStpe4 = () => {
    this.props.navigateNextStep3();
  };

  render() {

    // console.log("external props",this.props)

    // getting dropdown list options from redux persist
    const dropdownData = this.props.dropdownListData.dropdownList;
    const practiceTypeList = this.props.disciplineListData.disciplineList;

    const roleIdArrayForCmpny = [6];
    // getting related party role from dropdown json
    const roleOptions = dropdownData.lk_related_party_role.map(
      (element, index) => {
        if (
          roleIdArrayForCmpny.indexOf(element.lk_related_party_role_id) > -1
        ) {
          return (
            <option key={index} value={element.lk_related_party_role_id}>
              {element.role_name}
            </option>
          );
        }
      }
    );


    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }

    const isDropdownEmpty = !Object.keys(dropdownData).length;

    // getting title from dropdown json
    const titleOptions =
      dropdownData &&
      !isDropdownEmpty &&
      dropdownData.prefix.map((element, index) => (
        <option key={index} value={element.prefix_id}>
          {element.prefix_name}
        </option>
      ));

    return (
      <div className={style.companyInfoMainWrapper}>
        <div className={style.headingWrapper}>
          <h2>Step 2 : Contact Creation - External Practitioner Info</h2>
          <p>
            Please share details as requested on the form below.
          </p>
          <hr />
        </div>
        <div className="row">
          <div className="col-md-10 col-xl-6">
            <div className="custom-stepper">
              <div className={style.stepperWrapper}>
                <div className="custom-stepper">
                  <ul>
                    <li>
                      <h3 onClick={this.goBack}>1</h3>
                    </li>
                    <li>
                      <h3 className="active">2</h3>
                    </li>
                    <li>
                      <h3 onClick={this.goNext}>3</h3>
                    </li>
                    <li>
                      <h3 onClick={this.goNextStpe4}>4</h3>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <div className="custom-stepper">
                <div className={style.stepperWrapper}>
                  <Stepper
                    steps={[
                      { label: "" },
                      { label: "" },
                      { label: "" },
                      { label: "" },
                    ]}
                    activeStep={0}
                    styleConfig={{
                      inactiveBgColor: "#fff",
                      activeBgColor: "#00467F",
                      inactiveTextColor: "#00467F",
                      activeTextColor: "#fff",
                      completedBgColor: "#fff",
                      completedTextColor: "#00467F",
                    }}
                    connectorStyleConfig={{
                      disabledColor: "#00467F33 ",
                      size: 2,
                    }}
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div
          className={`form-controls-wrapper ${style.companyInfoFormWrapper}`}
        >
          {/* <div className={style.relatedPartyRoleWrapper}>
            <h4>Select the Role of Contact</h4>
            <div className="row form-group">
              <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                <label>
                  Role of the contact <span className="mandatory">*</span>
                </label>
                <Field
                  as="select"
                  name="cRelatedPartyRole"
                  className={
                    "form-control" +
                    (this.props.errors.cRelatedPartyRole &&
                    this.props.touched.cRelatedPartyRole
                      ? " is-invalid"
                      : "")
                  }
                >
                  <option value="">Select a Role</option>
                  {roleOptions}
                </Field>
                {this.props.errors.cRelatedPartyRole &&
                this.props.touched.cRelatedPartyRole ? (
                  <div className={style.errMsg}>
                    {this.props.errors.cRelatedPartyRole}
                  </div>
                ) : null}
              </div>
            </div>
          </div> */}

          <h4>Enter the below details for the Contact</h4>
          <div className="row form-group">
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="title">
                Title <span className="mandatory">*</span>
              </label>
              <Field
                name="title"
                as="select"
                placeholder="Select Title"
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.title && this.props.touched.title
                    ? " is-invalid"
                    : "")
                }
              >
                <option value="">Select Title</option>
                {titleOptions}
              </Field>
              {this.props.errors.title && this.props.touched.title ? (
                <div className={style.errMsg}>{this.props.errors.title}</div>
              ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="firstName">
                First Names <span className="mandatory">*</span>
              </label>
              <Field
                name="firstName"
                placeholder="First Names"
                maxLength="20"
                value={this.props.values.firstName}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.firstName && this.props.touched.firstName
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.firstName && this.props.touched.firstName ? (
                <div className={style.errMsg}>
                  {this.props.errors.firstName}
                </div>
              ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="lastName">
                Last Name <span className="mandatory">*</span>
              </label>
              <Field
                name="lastName"
                placeholder="Last Name"
                maxLength="20"
                value={this.props.values.lastName}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.lastName && this.props.touched.lastName
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.lastName && this.props.touched.lastName ? (
                <div className={style.errMsg}>{this.props.errors.lastName}</div>
              ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="discipline_code">
                Practice Type <span className="mandatory">*</span>
              </label>
              <Select
                showSearch
                allowClear={true}
                name="discipline_code"
                placeholder="Search practice type"
                optionFilterProp="children"
                onChange={(value, obj) => {
                  //console.log("name", name);
                  this.props.setFieldValue("discipline_code", value);
                  this.props.setFieldValue("discipline_name", obj && obj.children);
                }}
                className={
                  (this.props.errors.discipline_code && this.props.touched.discipline_code
                    ? " is-invalid"
                    : "")
                }
                filterOption={(input, option) =>
                  option.children.toString()
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                value={this.props.values.discipline_code || undefined}
              >
                {practiceTypeList &&
                  practiceTypeList.map((element, index) => (
                    <Option key={index} value={element.Code}>
                      {element.Description}
                    </Option>
                  ))}
              </Select>
              {this.props.errors.discipline_code && this.props.touched.discipline_code ? (
                <div className={style.errMsg}>{this.props.errors.discipline_code}</div>
              ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="vat_registration_number">
                VAT Registration Number{" "}
              </label>
              <Field
                name="vat_registration_number"
                placeholder="VAT Registration Number"
                value={this.props.values.vat_registration_number}
                maxLength="15"
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.vat_registration_number &&
                    this.props.touched.vat_registration_number
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.vat_registration_number &&
                this.props.touched.vat_registration_number ? (
                  <div className={style.errMsg}>
                    {this.props.errors.vat_registration_number}
                  </div>
                ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="billing_practise_pcns_number">
                Billing Practice PCNS No.<span className="mandatory">*</span>
              </label>
              <Field
                name="billing_practise_pcns_number"
                placeholder="PCNS Number"
                value={this.props.values.billing_practise_pcns_number}
                maxLength="18"
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.billing_practise_pcns_number &&
                    this.props.touched.billing_practise_pcns_number
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.billing_practise_pcns_number &&
                this.props.touched.billing_practise_pcns_number ? (
                  <div className={style.errMsg}>
                    {this.props.errors.billing_practise_pcns_number}
                  </div>
                ) : null}
            </div>

            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="cms_registration_number">
                CMS Registration Number<span className="mandatory">*</span>
              </label>
              <Field
                name="cms_registration_number"
                placeholder="CMS Registration Number"
                value={this.props.values.cms_registration_number}
                maxLength="20"
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.cms_registration_number &&
                    this.props.touched.cms_registration_number
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.cms_registration_number &&
                this.props.touched.cms_registration_number ? (
                  <div className={style.errMsg}>
                    {this.props.errors.cms_registration_number}
                  </div>
                ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="cellNumber">
                Contact Number <span className="mandatory">*</span>
              </label>
              <Field
                name="cellNumber"
                placeholder="Cell Phone Number"
                maxLength="15"
                value={this.props.values.cellNumber}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.cellNumber && this.props.touched.cellNumber
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.cellNumber && this.props.touched.cellNumber ? (
                <div className={style.errMsg}>
                  {this.props.errors.cellNumber}
                </div>
              ) : null}
            </div>

            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="emailAddress">
                Email Address <span className="mandatory">*</span>
              </label>
              <Field
                name="emailAddress"
                placeholder="Email Address"
                value={this.props.values.emailAddress}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.emailAddress &&
                    this.props.touched.emailAddress
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.emailAddress &&
                this.props.touched.emailAddress ? (
                  <div className={style.errMsg}>
                    {this.props.errors.emailAddress}
                  </div>
                ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="physicalAddress">
                Physical Address
              </label>
              <Field
                name="physicalAddress"
                placeholder="Physical Address"
                maxLength="50"
                value={this.props.values.physicalAddress}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.physicalAddress &&
                    this.props.touched.physicalAddress
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.physicalAddress &&
                this.props.touched.physicalAddress ? (
                  <div className={style.errMsg}>
                    {this.props.errors.physicalAddress}
                  </div>
                ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="postalAddress">Postal Address (Optional)</label>
              <Field
                name="postalAddress"
                placeholder="Postal Address"
                className="form-control"
                maxLength="50"
                value={this.props.values.postalAddress}
                onChange={this.props.handleChange}
              />
            </div>

          </div>

          <div className="row form-group">
            <div className="col-md-12 d-flex flex-wrap mb-3">
              <label htmlFor="categories" className="mr-3">
                Categories:{" "}
              </label>
              <div className="custom-control custom-checkbox mr-3">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  onChange={(e) => {
                    this.props.setFieldValue("main_surgeon", e.target.checked ? 1 : 0)
                  }}
                  id="main_surgeon"
                  checked={this.props.values.main_surgeon === 1}
                  name="main_surgeon" />
                <label
                  className="custom-control-label"
                  htmlFor="main_surgeon"
                >
                  Main Surgeon
                </label>
              </div>
              <div className="custom-control custom-checkbox mr-3">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  onChange={(e) => {
                    this.props.setFieldValue("assistant", e.target.checked ? 1 : 0)
                  }}
                  checked={this.props.values.assistant === 1}
                  id="assistant"
                  name="assistant" />
                <label
                  className="custom-control-label"
                  htmlFor="assistant"
                >
                  Assistant
                </label>
              </div><div className="custom-control custom-checkbox mr-3">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  onChange={(e) => {
                    this.props.setFieldValue("anaesthetist", e.target.checked ? 1 : 0)
                  }}
                  checked={this.props.values.anaesthetist === 1}
                  id="anaesthetist"
                  name="anaesthetist" />
                <label
                  className="custom-control-label"
                  htmlFor="anaesthetist"
                >
                  Aneasthetics
                </label>
              </div><div className="custom-control custom-checkbox mr-3">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  onChange={(e) => {
                    this.props.setFieldValue("locum", e.target.checked ? 1 : 0)
                  }}
                  checked={this.props.values.locum === 1}
                  id="locum"
                  name="locum" />
                <label
                  className="custom-control-label"
                  htmlFor="locum"
                >
                  Locum
                </label>
              </div><div className="custom-control custom-checkbox mr-3">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  onChange={(e) => {
                    this.props.setFieldValue("referring_practitioner", e.target.checked ? 1 : 0)
                  }}
                  checked={this.props.values.referring_practitioner === 1}
                  id="referring_practitioner"
                  name="referring_practitioner" />
                <label
                  className="custom-control-label"
                  htmlFor="referring_practitioner"
                >
                  Referring Practitioner
                </label>
              </div>
            </div>
          </div>

          <hr className={style.formBottomLine} />
          {Object.keys(this.props.errors).length > 0 &&
            this.state.nextClicked && (
              <div className="text-danger">
                Please fill all mandatory fields!
              </div>
            )}
          <div
            className={` d-flex
              justify-content-between
              flex-column-reverse
              flex-md-row
              align-items-center ${style.btnWrapper}`}
          >
            <button
              type="button"
              className="btn form-primary-btn mb-3"
              onClick={this.props.navigateBack}
              disabled={this.props.pageIndex === 0}
            >
              Back
            </button>

            <button
              type="button"
              className="btn form-primary-btn mb-3"
              onClick={() => {
                this.props.navigateNext();
                this.setState({ nextClicked: true });
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
    disciplineListData: state.disciplineList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
    fetchDisciplineList: () => dispatch(fetchDisciplineList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExternalPractitionerInfo);
